import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "product-item-list"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "asin-image-container"
};
var _hoisted_4 = {
  class: "asin-content-container"
};
var _hoisted_5 = {
  class: "asin-title"
};
var _hoisted_6 = {
  class: "asin-price"
};
var _hoisted_7 = {
  class: "price"
};
var _hoisted_8 = {
  key: 0,
  class: "badge"
};
var _hoisted_9 = {
  key: 0,
  class: "deal-content"
};
var _hoisted_10 = {
  class: "deal-content-badge"
};
var _hoisted_11 = {
  class: "deal-time-countdown"
};
var _hoisted_12 = {
  class: "deal-content-badge"
};
var _hoisted_13 = {
  class: "deal-time-countdown"
};
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  class: "badge-line"
};
var _hoisted_16 = ["src"];
var _hoisted_17 = {
  key: 0,
  class: "badge-text"
};
var _hoisted_18 = ["onClick"];
var _hoisted_19 = ["src"];
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import constants from '@/constants';
import { useLess } from '@/models/hooks';
import { useI18n } from 'vue-i18n';
import CountDown from '../countDown/CountDown.vue';
import { getNewCustomerCoupon } from '@/utils/promotionCommon.js';
import { addCartList, showToastText, isShowPIPLConfirmAlertView, imageCutEdgeAndSetSize } from '@/utils/common';
import { closeToast } from 'vant';
var SHOW_TOAST_DURATION = 1000; // 1000ms

export default {
  __name: 'ProductItem',
  props: {
    columns: {
      type: Number,
      default: () => 2
    },
    asinList: {
      type: Array,
      default: () => []
    },
    asinDealData: {
      type: Object,
      required: false,
      default: () => null
    },
    isShowUnit: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  emits: ['addCartConfirm', 'reloadingDetailPageData', 'openApp', 'update:asinList'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    useLess('components/ProductItem.less');
    var MERCHANT_BADGE_MAP = constants.MERCHANT_BADGE_MAP;
    var COLUMNS = {
      THREE: 3,
      TWO: 2
    };
    var STOP_ROUTE_NAME = ['detailPage'];
    var router = useRouter();
    var route = useRoute();
    var couponInfo = ref(null);
    var onClickBuyPop = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
        var _route$query;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return isShowPIPLConfirmAlertView();
            case 2:
              if (!_context.sent) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              closeToast();
              if (!(route !== null && route !== void 0 && (_route$query = route.query) !== null && _route$query !== void 0 && _route$query.isShare)) {
                _context.next = 8;
                break;
              }
              emit('openApp');
              return _context.abrupt("return");
            case 8:
              addCartList(item.asin, item.merchantId, 1, true, () => {
                showToastText(t('modules.checkout.SUCCESS_ADD_CART'), true, SHOW_TOAST_DURATION);
                emit('addCartConfirm', true, item.asin);
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onClickBuyPop(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var handleOpen = item => {
      var _route$params, _route$query2;
      // The current page is DP and has the same ASIN as the current page. The following actions will not be performed
      if (item.asin === ((_route$params = route.params) === null || _route$params === void 0 ? void 0 : _route$params.asinId) && STOP_ROUTE_NAME.includes(route.name)) {
        return;
      }
      emit('reloadingDetailPageData');
      if (route !== null && route !== void 0 && (_route$query2 = route.query) !== null && _route$query2 !== void 0 && _route$query2.isShare) {
        router.push({
          name: 'detailPage',
          params: {
            asinId: item.asin
          },
          query: {
            isShare: true
          }
        });
        return;
      }
      router.push({
        name: 'detailPage',
        params: {
          asinId: item.asin
        }
      });
    };
    var calculateDealTimeRemaining = item => {
      var _item$dealOffer;
      return (item === null || item === void 0 ? void 0 : (_item$dealOffer = item.dealOffer) === null || _item$dealOffer === void 0 ? void 0 : _item$dealOffer.endTime) - new Date().getTime();
    };
    var dealTimeFinish = asinItem => {
      var asinlist = props.asinList.map(item => {
        if (item.asin === asinItem.asin) {
          item.dealOffer = null;
        }
        return item;
      });
      emit('update:asinList', asinlist);
    };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$getNewCustomer, promotionList;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getNewCustomerCoupon();
          case 2:
            _yield$getNewCustomer = _context2.sent;
            promotionList = _yield$getNewCustomer.promotionList;
            couponInfo.value = (promotionList === null || promotionList === void 0 ? void 0 : promotionList.length) > 0 ? promotionList[0] : null;
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return (_ctx, _cache) => {
      var _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.asinList, asinItem => {
        var _asinItem$dealOffer, _unref2, _unref2$asinItem$merc;
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["product-item", [__props.columns === COLUMNS.THREE ? 'columns-three' : 'columns-two']]),
          key: asinItem.id,
          onClick: $event => handleOpen(asinItem)
        }, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("img", {
          key: asinItem.mainImage,
          alt: ""
        })), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(asinItem.mainImage)]])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(asinItem.title), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [__props.isShowUnit ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(_unref(t)('common.currencyUnit')), 1)], 64)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(asinItem.buyPrice), 1)]), couponInfo.value ? (_openBlock(), _createElementBlock("span", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_unref(t)('common.FULL_REDUCTION_COUPON', {
          amount: couponInfo.value.threshold,
          promotion: couponInfo.value.amount
        })), 1)])) : _createCommentVNode("", true)]), __props.asinDealData ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, _toDisplayString(_unref(t)(`${__props.asinDealData.dealTypeName}`)), 1)]), _createElementVNode("span", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('common.TIME_REMAINING')), 1), _createVNode(CountDown, {
          time: calculateDealTimeRemaining(__props.asinDealData),
          onFinish: $event => dealTimeFinish(asinItem)
        }, null, 8, ["time", "onFinish"])])])) : _createCommentVNode("", true), (asinItem === null || asinItem === void 0 ? void 0 : (_asinItem$dealOffer = asinItem.dealOffer) === null || _asinItem$dealOffer === void 0 ? void 0 : _asinItem$dealOffer.state) === _unref(constants).DEAL_OFFER_STATE.AVAILABLE ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["deal-content", {
            'deal-content-three': __props.columns === COLUMNS.THREE
          }])
        }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, _toDisplayString(_unref(t)(`common.${asinItem.dealOffer.dealType}`)), 1)]), _createElementVNode("span", _hoisted_13, [__props.columns !== COLUMNS.THREE ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)('common.TIME_REMAINING')), 1)) : _createCommentVNode("", true), _createVNode(CountDown, {
          time: calculateDealTimeRemaining(asinItem),
          onFinish: $event => dealTimeFinish(asinItem)
        }, null, 8, ["time", "onFinish"])])], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
          src: (_unref2 = _unref(MERCHANT_BADGE_MAP)) === null || _unref2 === void 0 ? void 0 : (_unref2$asinItem$merc = _unref2[asinItem.merchantId]) === null || _unref2$asinItem$merc === void 0 ? void 0 : _unref2$asinItem$merc.badgeURL,
          alt: ""
        }, null, 8, _hoisted_16), asinItem.isGlobalStoreFreeShippingProgram ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)('common.FREE_SHIPPING')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: "btn-buy",
          onClick: _withModifiers($event => onClickBuyPop(asinItem), ["stop"])
        }, [_createElementVNode("img", {
          src: `${_unref(constants).IMAGE_URL}assets/svg/detailTags/stroke.svg`,
          alt: ""
        }, null, 8, _hoisted_19)], 8, _hoisted_18)])], 10, _hoisted_2);
      }), 128))]);
    };
  }
};